import {Button, FormControl, FormLabel, IconButton} from "@chakra-ui/react";
import { Select } from "chakra-react-select";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import { getAxiosInstance } from "../utils/axiosInstance";
import axios from "axios";
import { toast } from "react-toastify";
import {MdClose} from "react-icons/md";

interface SelectCompanyAndPlaceOfBusinessProps {
    onChangeCompany: (value?: string) => void;
    valueCompany?: string;
    companyFiledName?: string;
    onChangePlaceOfBusiness: (value?: string) => void;
    valuePlaceOfBusiness?: string;
    placeOfBusinessName?: string;
}

const SelectCompanyAndPlaceOfBusiness = (props: SelectCompanyAndPlaceOfBusinessProps) => {
    const {
        onChangeCompany,
        onChangePlaceOfBusiness,
        valueCompany,
        valuePlaceOfBusiness,
    } = props;

    const { t } = useTranslation("translations");

    const [companies, setCompanies] = useState<{ value: string, label: string, colorScheme: string }[]>([]);
    const [placeOfBusiness, setPlaceOfBusiness] = useState<{ value: string, label: string, colorScheme: string }[]>([]);

    const fetchCompanies = async () => {
        try {
            const res = await getAxiosInstance().get(`/Companies`, { params: { PageNumber: 1, PageSize: 10 } });
            setCompanies(res.data.map((x: any) => ({ value: x.id, label: x.name, colorScheme: "red" })));
        } catch (error) {
            if (axios.isAxiosError(error)) {
                toast.error(`${error.response?.data}`, { position: toast.POSITION.BOTTOM_RIGHT })
            } else {
                toast.error(t(`Could not retrieve the companies from the database!`), { position: toast.POSITION.BOTTOM_RIGHT });
            }
        }
    }

    const fetchPlaceOfBusiness = async () => {
        try {
            const res = await getAxiosInstance().get(`/Companies/company-place-of-business/${valueCompany}`);
            setPlaceOfBusiness(res.data.map((x: any) => ({ value: x.id, label: x.name, colorScheme: "red" })));
        } catch (error) {
            if (axios.isAxiosError(error) && error.response?.status !== 400) {
                toast.error(`${error.response?.data}`, { position: toast.POSITION.BOTTOM_RIGHT })
            }
        }
    }

    useEffect(() => {
        fetchCompanies().then();
    }, []);

    useEffect(() => {
        fetchPlaceOfBusiness().then();
    }, [valueCompany])

    return <>
        <FormControl className="mx-2">
            <FormLabel>{props.companyFiledName ?? t("SELECT_COMPANY")}</FormLabel>
            <Select
                name={props.companyFiledName ?? t("SELECT_COMPANY")}
                options={companies}
                placeholder={t("SELECT_COMPANY")}
                value={ valueCompany ? companies[companies?.findIndex((x) => x.value == valueCompany)] : []}
                onChange={(e: any) => {
                    if (e) {
                        onChangeCompany(e.value);
                    }
                }}
            />
        </FormControl>
        <FormControl className="mx-2">
            <FormLabel>{props.placeOfBusinessName ?? t("SELECT_PLACE_OF_BUSINESS")}</FormLabel>
            <Select
                name={props.placeOfBusinessName ?? t("SELECT_PLACE_OF_BUSINESS")}
                options={placeOfBusiness}
                value={valuePlaceOfBusiness ? placeOfBusiness[placeOfBusiness.findIndex(x => x.value === valuePlaceOfBusiness)] : []}
                onChange={
                    (e) => {
                        if (e) onChangePlaceOfBusiness(e.value);
                    }
                }
                placeholder={t("SELECT_PLACE_OF_BUSINESS")}
            />
        </FormControl>
        <IconButton
            colorScheme={"white"}
            aria-label='Action'
            fontSize='30px'
            className="my-6 md:my-[31px]"
            rounded={15}
            icon={<MdClose color={"red"} />}
            onClick={() => {
                onChangePlaceOfBusiness(undefined);
                onChangeCompany(undefined);
            }}
        />
    </>
}

export default SelectCompanyAndPlaceOfBusiness;